import BatchImport from './BatchImport'

export default BatchImport
